import Logo from '@/components/logo/logo';

import { Flex } from 'antd';
import styles from './forgot-password.module.scss';
import {
  ForgotPasswordFieldType,
  ForgotPasswordForm,
} from '@/components/forgot-password-form/forgot-password-form';
import { CheckEmail } from '@/components/check-email/check-email';
import { useState } from 'react';
import { useAuth } from '@/hooks/use-auth/use-auth';
import arrowSvg from '@/assets/images/arrow.svg?url';

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [showMessage, setShowMessage] = useState(false);
  const { sendEmailToResetPassword, isPendingSendingEmail, errorSendingEmail } = useAuth();

  const onFinish = ({ email }: ForgotPasswordFieldType) => {
    setEmail(email);
    setShowMessage(true);
    sendEmailToResetPassword({ email });
  };

  const resend = () => {
    sendEmailToResetPassword({ email });
  };

  return (
    <>
      <Flex vertical align="center">
        <Flex className={styles.logo}>
          <Logo />
        </Flex>

        {showMessage ? (
          <CheckEmail
            onResendEmail={resend}
            email={email}
            showEmailInput={() => setShowMessage(false)}
          />
        ) : (
          <ForgotPasswordForm
            onSubmit={onFinish}
            isLoading={isPendingSendingEmail}
            error={errorSendingEmail?.message}
          />
        )}
        <img className={styles.arrow} src={arrowSvg} />
      </Flex>
    </>
  );
}
